<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/sjwh">盛京文化</router-link> >
      <router-link to="/sjwh">百年历史</router-link> >
      {{ photo.bt }}
    </div>

    <div class="container-width">
      <div class="" :ref="`fixedBox`"></div>
      <div class="relevance">
        <span @click="changePhotoAlbum('prev')">上一图集({{ beforeBt }})</span>

        <span @click="changePhotoAlbum('next')">下一图集({{ afterBt }})</span>
      </div>
    </div>
    <div class="c-img">
      <p>
        <span>
          {{ photo.bt }}
        </span>
      </p>
      <div class="img-bg">
        <div class="swiper-container gallery-top">
          <div class="swiper-wrapper" style="display: flex;align-items: center;">
            <div
              class="swiper-slide"
              style="background: none"
              v-for="(item, index) in current"
              :key="index"
            >
              <img :src="item.img" />
            </div>
          </div>
          <!-- Add Arrows -->
          <div class="swiper-button-next swiper-button-white"></div>
          <div class="swiper-button-prev swiper-button-white"></div>
        </div>
        <div class="swiper-container gallery-thumbs">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in current"
              :key="index"
            >
              <img :src="item.img" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <img id="photo" :src="photo.img" /> -->
  </div>
  <!-- <div class="">
    <div class="neiye_banner">
      <BANNER></BANNER>
    </div>

    <div class="main">
      <div class="container">
        <div class="location">
          <router-link to="/">网站首页</router-link>
          <router-link to="/sjwh">&nbsp;&gt;&nbsp;盛京文化</router-link>
          <router-link to="/sjwh">&nbsp;&gt;&nbsp;百年历史</router-link>
        </div>

        <div class="tv_main clearfix">
          <div class="tv_main_left fl">
            <SLIDE></SLIDE>
          </div>
          <div class="bainianlishi_right fr">
            <div class="article_tit article_a">
              <h1>图片盛京</h1>
            </div>
            <div class="weiduduan clearfix">
              <div class="photoMHD">
                <div class="title">
                  <div class="txt">
                    <h1>
                      {{ photo.bt }}
                      <span class="num"
                        >(<em id="photoIndex">{{ imgIndex }}</em
                        >/ {{ current.length }} )</span
                      >
                    </h1>
                  </div>
                </div>

                <div class="photoNews">
                  <div id="picDiv" v-show="!showAllPic">
                    <div
                      class="pic"
                      id="photoView"
                      style="width: 866px; height: 800px"
                    >
                      <div class="photo_prev">
                        <a
                          class="btn_pphoto"
                          target="_self"
                          hidefocus="true"
                          title="上一张，支持 '← '翻页"
                          @click="changeImg('prev')"
                        ></a>
                      </div>
                      <div class="photo_next">
                        <a
                          class="btn_nphoto"
                          target="_self"
                          hidefocus="true"
                          title="下一张，支持 '→ '翻页"
                          @click="changeImg('next')"
                        ></a>
                      </div>
                      <a id="photoimg">
                        <img id="photo" :src="photo.img" />
                      </a>
                    </div>
                  </div>

                  <div class="allPic" id="moretab" v-show="showAllPic">
                    <div class="leftArae">
                      <a id="moreLeft" style="display: none"></a>
                    </div>

                    <div class="smallpic_box clearfix">
                      <div
                        style="
                          height: 560px;
                          overflow: auto;
                          position: relative;
                          width: 100%;
                        "
                      >
                        <div id="imageListView" class="smallpic_con clearfix">
                          <ul>
                            <li
                              :class="item.id == photo.id ? 'current' : ''"
                              v-for="(item, index) in current"
                              :key="index"
                            >
                              <i></i
                              ><a @click="changeImg('click', item)"
                                ><img :src="item.img"
                              /></a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>

                    <div class="rightArae">
                      <a id="moreRight" style="display: none"></a>
                    </div>

                    <div class="clear"></div>

                    <div class="btn" id="btnPage">
                      <a id="btnPage_0" class="current">&nbsp;</a
                      ><a id="btnPage_1" class="">&nbsp;</a>
                    </div>
                  </div>

                  <div class="zy clearfix">
                    <div class="wrap_text">
                      <div class="title">
                        <div class="txt" v-show="!showAllPic">
                          <p class="text_con" id="photoDesc">
                            {{ photo.introduction }}
                          </p>

                          <em id="photoIndex"></em>
                        </div>

                        <div class="function">
                          <a
                            class="return"
                            title="返回幻灯模式"
                            v-show="showAllPic"
                            @click="showAllPic = !showAllPic"
                            >返回幻灯模式</a
                          >
                          <a
                            class="ckap"
                            title="查看全部图片"
                            @click="showAllPic = !showAllPic"
                            v-show="!showAllPic"
                            >查看全部图片</a
                          >
                          <a
                            class="ckbp"
                            id="btnOrig"
                            data-toggle="modal"
                            data-target="#myModal"
                            title="查看大图"
                            target="_blank"
                            href="javascript:void(0)"
                            v-show="!showAllPic"
                            >查看大图</a
                          >
                          <a
                            class="return"
                            title="返回幻灯"
                            style="display: none"
                          ></a>
                        </div>

                        <div
                          class="modal fade"
                          id="myModal"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="whModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog">
                            <div class="modal-content">
                              <div class="modal-header">
                                <button
                                  type="button"
                                  class="close"
                                  data-dismiss="modal"
                                  aria-hidden="true"
                                >
                                  ×
                                </button>

                                <h4 class="modal-title" id="whModalLabel">
                                  百年历史
                                </h4>
                              </div>

                              <div
                                class="modal-body"
                                style="text-align: center"
                              >
                                <img id="chen_modal" :src="photo.img" />
                              </div>

                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-default"
                                  data-dismiss="modal"
                                >
                                  关闭
                                </button>
                              </div>
                            </div>
                          
                          </div>
                         
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="clear"></div>
                  <div class="photoList" id="picList_b" v-show="!showAllPic">
                    <div class="before">
                      <a id="prevSet"
                        ><img
                          :src="beforeImg"
                          max-width="100%"
                          height="69"
                          @click="changePhotoAlbum('prev')"
                      /></a>

                      <p>
                        <a @click="changePhotoAlbum('prev')"
                          >&lt;&lt;&nbsp;上一图集</a
                        >
                      </p>
                    </div>
                    <div class="clear"></div>
                    <div class="picList" id="scrl" style="width: 532px">
                      <div id="scrlPrev" class="l1">
                        <a
                          id="scrlPrev_b"
                          class="no"
                          @click="changeImg('prev')"
                        ></a>
                      </div>

                      <div class="l2">
                        <div class="listM" :ref="`fixedBox`">
                          <ul
                            style="position: absolute"
                            :style="`width:${
                              signleWidth * current.length
                            }px;transform:translate(${scrollResultWidth}px,0);transition:1s;`"
                          >
                            <li v-for="(item, index) in current" :key="index">
                              <a
                                ><img
                                  :src="item.img"
                                  alt=""
                                  :class="item.id == photo.id ? 'current' : ''"
                                  @click="changeImg('click', item)"
                              /></a>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div id="scrlNext" class="l3">
                        <a id="scrlNext_b" @click="changeImg('next')"></a>
                      </div>
                    </div>

                    <div class="after">
                      <a id="nextSet"
                        ><img
                          :src="afterImg"
                          max-width="100%"
                          height="69"
                          @click="changePhotoAlbum('next')"
                      /></a>

                      <p>
                        <a @click="changePhotoAlbum('next')" title="百年历史"
                          >下一图集&nbsp;&gt;&gt;</a
                        >
                      </p>
                    </div>

                    <div class="clear"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</template>

<script>
import service from "../../service/sjwh";
import BANNER from "../../components/banner/sjwh";
import config from "../../config/dev";
export default {
  name: "SJWHARTICLE",
  data() {
    return {
      navigationData: [
        {
          name: "百年历史",
          path: "/sjwh",
          width: "50%",
        },
        {
          name: "院标/办院理念/院训/院歌",
          path: "/sjwh/yuange",
          width: "50%",
        },
        // {
        //   name: "盛京医讯",
        //   path: "/sjwh/zhoukan",
        //   width: "33%",
        // },
        // {
        //   name: "盛京TV",
        //   path: "/sjwh/tv",
        // },
        {
          name: "盛京映像",
          path: "/sjwh/yingxiang",
        },
        // {
        //   name: "盛京医院的故事",
        //   path: "/sjwh/gushi",
        // },
      ],
      currentPath: "/sjwh",
      photo: {
        img: "", // 当前显示大图
        id: "", // 当前图片ID
        bt: "",
      },
      current: {},
      before: {},
      beforeBt: "",
      beforeImg: "",
      afterBt: "",
      afterImg: "",
      after: {},
      imgIndex: 1,
      showAllPic: false,
      // scroll
      currentProgressId: "",
      scrollResultWidth: 0, //transform滚动的距离
      signleWidth: 115, //单个流程的宽度
      activeName: 0,
      currentClickNumber: 0,
      noScrollRight: true,
    };
  },
  components: { BANNER },
  computed: {},
  created() {},
  beforeMount() {},
  methods: {
    init(id) {
      let parmes = {
        id: id,
      };
      service.getThreeInfo(parmes, (res) => {
        if (res.current && res.current.length) {
          res.current.map((item) => {
            item.img = item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
          });
          this.photo = { ...res.current[0] };
        }
        if (res.before && res.before.length) {
          res.before.map((item) => {
            item.img = item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
          });

          this.beforeImg = res.before[0].img;
          this.beforeBt = res.before[0].bt;
        } else {
          this.before = { ...res.current };
          this.beforeImg = res.current[0].img;
          this.beforeBt = res.current[0].bt;
        }

        if (res.after && res.after.length) {
          res.after.map((item) => {
            item.img = item.img = item.img
              ? config.url +
                "/file/downloadFile/" +
                item.img +
                "?isDownload=true"
              : "";
          });
          this.afterImg = res.after[0].img;
          this.afterBt = res.after[0].bt;
        } else {
          this.after = { ...res.current };
          this.afterImg = res.current[0].img;
          this.afterBt = res.current[0].bt;
        }

        this.current = res.current;
        this.before = res.before;
        this.after = res.after;
        this.initgoRightArrow();
        this.$nextTick(() => {
          this.swiperImg();
        });
      });
    },
    changeImg(type, data) {
      // 小图片点击事件
      this.showAllPic = false;
      if (type == "click") {
        this.current.findIndex((val, num) => {
          if (val.id == data.id) {
            this.imgIndex = num + 1;
            this.photo = { ...this.current[num] };
            return num;
          }
        });
        return;
      }

      // 前一张
      let index = 0;
      this.current.map((val, num) => {
        if (val.id == this.photo.id) {
          index = num;
        }
      });

      if (type == "prev") {
        if (this.imgIndex == 1) {
          this.photo = { ...this.current[0] };
          return;
        } else {
          this.imgIndex = index;
          this.photo = { ...this.current[index - 1] };
        }
        //如果右点击的次数大于0，才可以左滚
        if (this.currentClickNumber > 0) {
          this.currentClickNumber -= 1;
          this.noScrollRight = true;
          this.fnScrollWidth("reduce");
        } else {
          return false;
        }
        // if (index == 0) {
        //   if (this.before && this.before.length && this.before[0].hisId) {
        //     this.init(this.before[0].hisId);
        //   }
        //   return;
        // } else {
        //   this.init(this.before[0].hisId);
        // }
        return;
      }
      if (type == "next") {
        if (this.imgIndex == this.current.length) {
          this.photo = { ...this.current[this.current.length - 1] };
          return;
        } else {
          this.imgIndex += 1;
          this.photo = { ...this.current[index + 1] };

          const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
          const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
          //如果最后一个流程图标已经展示出来，则停止滚动
          if (this.currentClickNumber + canNumber >= this.current.length) {
            return;
          }
          //说明放不下有滚动条
          if (this.current.length > canNumber) {
            this.currentClickNumber += 1;
            if (this.currentClickNumber + canNumber >= this.current.length) {
              this.noScrollRight = false;
            }
            this.fnScrollWidth("add");
          }
        }
      }
    },
    changePhotoAlbum(type) {
      this.imgIndex = 1;
      if (type == "prev") {
        if (this.before && this.before.length && this.before[0].hisId) {
          this.init(this.before[0].hisId);
        }
      } else {
        if (this.after && this.after.length && this.after[0].hisId) {
          this.init(this.after[0].hisId);
        }
      }
    },
    //初始化判断是否可以向右滚动
    initgoRightArrow() {
      const currentScrollWidth = this.$refs[`fixedBox`].clientWidth;
      const canNumber = Math.floor(currentScrollWidth / this.signleWidth); //可以放下的个数
      //如果最后一个流程图标已经展示出来，则停止滚动
      if (this.currentClickNumber + canNumber >= this.current.length) {
        this.noScrollRight = false;
        return;
      }
    },

    //translate的宽度
    fnScrollWidth(type) {
      let result = 0;
      if (type === "reduce") {
        result = 115;
      } else if (type === "add") {
        result = -115;
      } else {
        result = 0;
      }
      this.scrollResultWidth += result;
    },
    swiperImg() {
      var wW = $(window).width();
      var swipericon;
      if (wW > 768) {
        var galleryThumbs = new Swiper(".gallery-thumbs", {
          spaceBetween: 10,
          slidesPerView: 8,
          loop: true,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        });
      } else if (wW < 768) {
        var galleryThumbs = new Swiper(".gallery-thumbs", {
          spaceBetween: 10,
          slidesPerView: 4,
          loop: true,
          freeMode: true,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,
        });
      }

      var galleryTop = new Swiper(".gallery-top", {
        spaceBetween: 10,
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        thumbs: {
          swiper: galleryThumbs,
        },
      });
    },
  },
  mounted() {
    this.init(this.$route.query.atlas);
  },
  watch: {},
};
</script>

<style scoped lang="scss">
.relevance {
  height: 50px;
  display: flex;
  justify-content: space-between;
  font-size: 1.2rem;
  font-weight: bold;
  align-items: center;
  span {
    cursor: pointer;
  }
}
.c-img {
  background: #e6effc;
  width: 100%;
  height: 900px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  p {
    font-size: 1.2rem;
    font-weight: bold;
    height: 50px;
    line-height: 50px;
  }
  .img-bg {
    width: 1200px;
    height: 800px;
    // background: #fff;
    // display: flex;
    // justify-content: center;
    // align-items: center;
    img {
      max-height: 100%;
      max-width: 100%;
      box-shadow: 0px 0px 59px 0px rgba(19, 40, 83, 0.1);
    }
  }
}
.swiper-container {
  width: 100%;
  height: 600px;
  margin-left: auto;
  margin-right: auto;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 600px;
}
.swiper-slide img {
  object-fit: contain;
}
.gallery-top {
  height: 80%;
  width: 100%;
  border: 1px solid #dddddd;
}
.gallery-thumbs {
  height: 20%;
  box-sizing: border-box;
  padding: 10px 0;
  .swiper-slide {
    height: 100%;
    opacity: 0.4;
  }
  .swiper-slide-thumb-active {
    opacity: 1;
  }
}
@media only screen and (max-device-width: 728px) {
  .relevance {
    margin-top: 20px;
    flex-direction: column;
  }
  .c-img {
    height: 650px;
    .img-bg {
      width: 375px;
      max-height: 575px;
    }
  }
  .swiper-slide {
    width: 100%;
    max-height: 575px;
  }
}
</style>